export default __webpack_public_path__ + "6daa77fd88db976a32812fa1f99ebd2c.ogg";